import { usePageTitle } from '@app/hooks/usePageTitle';
import WalletsWidget from '@widgets/trades/wallets';

const TraderWalletsPage = () => {
  usePageTitle('Trader Wallets');

  return <WalletsWidget />;
};

export default TraderWalletsPage;
